import TOGGLE_SIDEBAR from './actionTypes';

const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});

export default toggleSidebar;
